module.exports = __webpack_public_path__ + "img/icon-telegram-notif.882397e.png";